import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ACTION_COMMANDS_MODAL_TYPE, ACTION_COMMANDS_TYPE } from '../../../../api/ActionCommandsInterface/constants';
import { ApiTrackingWhitelistEndpoints, Endpoints, RestartSessionBlacklistEndpoints } from '../../../../api/Constants';
import { MISSIONS_GAMEPLAY_STATE_NOT_FOUND_ERROR, PLATFORM } from '../../../../constants';
import { EVENT_TYPES } from '../../../../lib/analytics/constants';
import Logger from '../../../../lib/analytics/logger';
import useNotificationsPermissions from '../../../../screens/DynamicPopups/hooks/useNotificationsPermissions';
import utils from '../../../../utils';
import ENVIRONMENT_VARIABLES from '../../../../utils/environmentVariables';
import ERROR_CODE from '../../../../utils/errorCodes';
import { getObjectValues, hasObjectValues } from '../../../../utils/object';
import store from '../../../store';

var restartSessionState = function restartSessionState() {
  return store.getState().app.restartSession;
};

export var validApiTracking = function validApiTracking(url) {
  return ENVIRONMENT_VARIABLES.ENABLE_API_TRACKING === 'true' && ApiTrackingWhitelistEndpoints.includes(url);
};
export var validDiveErrorHandling = function validDiveErrorHandling() {
  return ENVIRONMENT_VARIABLES.DIVE_ERROR_HANDLING === 'yes';
};
export var validRestartSession = function validRestartSession(_ref) {
  var url = _ref.config.url;
  return !restartSessionState() && RestartSessionBlacklistEndpoints.indexOf(url) < 0;
};
export var restartSessionActive = function restartSessionActive(_ref2) {
  var url = _ref2.url;
  return restartSessionState() && url !== Endpoints.RESTART_SESSION;
};
export var skipEventError = function skipEventError(errorType) {
  return errorType === MISSIONS_GAMEPLAY_STATE_NOT_FOUND_ERROR;
};

var postTriggersNotify = function postTriggersNotify(executionId) {
  var _require = require('../../../query/actionCommands'),
      postTriggersNotify = _require.postTriggersNotify;

  store.dispatch(postTriggersNotify.initiate({
    executionId: executionId
  }));
};

var deleteTriggerNotify = function deleteTriggerNotify(executionId) {
  var _require2 = require('../../../query/actionCommands'),
      deleteTriggerNotify = _require2.deleteTriggerNotify;

  store.dispatch(deleteTriggerNotify.initiate({
    executionId: executionId
  }));
};

var getAssetsPackage = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(assetsPackageId) {
    var _require3, getAssetsPackage, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _require3 = require('../../../query/assetsPackage'), getAssetsPackage = _require3.getAssetsPackage;
            _context.prev = 1;
            _context.next = 4;
            return store.dispatch(getAssetsPackage.initiate({
              assetsPackageId: assetsPackageId
            })).unwrap();

          case 4:
            response = _context.sent;

            if (!(response === null || response === void 0 ? void 0 : response.assetsPackage)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", true);

          case 7:
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", false);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));

  return function getAssetsPackage(_x) {
    return _ref3.apply(this, arguments);
  };
}();

export var validateActionCommand = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(actions) {
    var actionsValidated, i, j, assetsLoaded;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            actionsValidated = [];
            i = 0;

          case 2:
            if (!(i < actions.length)) {
              _context3.next = 13;
              break;
            }

            _context3.prev = 3;
            return _context3.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var _store$getState$actio, _actions$i$gameTutori;

              var _actions$i, actionType, _actions$i$modal, modal, _useNotificationsPerm, checkIfPermissionsRequestable, requestNativePermissions;

              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _actions$i = actions[i], actionType = _actions$i.actionType, _actions$i$modal = _actions$i.modal, modal = _actions$i$modal === void 0 ? null : _actions$i$modal;
                      _context2.t0 = actionType;
                      _context2.next = _context2.t0 === ACTION_COMMANDS_TYPE.DISPLAY_MODAL ? 4 : _context2.t0 === ACTION_COMMANDS_TYPE.DISPLAY_MISSIONS_TUTORIAL ? 35 : _context2.t0 === ACTION_COMMANDS_TYPE.DISPLAY_GAME_TUTORIAL ? 37 : _context2.t0 === ACTION_COMMANDS_TYPE.DISPLAY_TOOLTIP ? 39 : 41;
                      break;

                    case 4:
                      _context2.t1 = modal.modalType;
                      _context2.next = _context2.t1 === ACTION_COMMANDS_MODAL_TYPE.ALLOW_NOTIFICATIONS ? 7 : _context2.t1 === ACTION_COMMANDS_MODAL_TYPE.DAILY_WHEEL ? 30 : 32;
                      break;

                    case 7:
                      if (!(utils.getPlatform() !== PLATFORM.WEB)) {
                        _context2.next = 28;
                        break;
                      }

                      _useNotificationsPerm = useNotificationsPermissions(), checkIfPermissionsRequestable = _useNotificationsPerm.checkIfPermissionsRequestable, requestNativePermissions = _useNotificationsPerm.requestNativePermissions;

                      if (!modal.nativeDialog) {
                        _context2.next = 19;
                        break;
                      }

                      _context2.next = 12;
                      return requestNativePermissions(modal.modalType, modal.onDisplayAction);

                    case 12:
                      if (!_context2.sent) {
                        _context2.next = 16;
                        break;
                      }

                      postTriggersNotify(modal.onDisplayAction.triggerExecution.executionId);
                      _context2.next = 17;
                      break;

                    case 16:
                      deleteTriggerNotify(modal.onDismissAction.triggerExecution.executionId);

                    case 17:
                      _context2.next = 26;
                      break;

                    case 19:
                      _context2.next = 21;
                      return checkIfPermissionsRequestable();

                    case 21:
                      if (!_context2.sent) {
                        _context2.next = 25;
                        break;
                      }

                      actionsValidated.push(actions[i]);
                      _context2.next = 26;
                      break;

                    case 25:
                      deleteTriggerNotify(modal.onDismissAction.triggerExecution.executionId);

                    case 26:
                      _context2.next = 29;
                      break;

                    case 28:
                      deleteTriggerNotify(modal.onDismissAction.triggerExecution.executionId);

                    case 29:
                      return _context2.abrupt("break", 34);

                    case 30:
                      if (utils.quickObjectComparision(store.getState().actionCommands.lastActionExecuted, actions[i]) === false) actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 34);

                    case 32:
                      if (getObjectValues(ACTION_COMMANDS_MODAL_TYPE).find(function (val) {
                        return val === modal.modalType;
                      }) !== undefined) actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 34);

                    case 34:
                      return _context2.abrupt("break", 42);

                    case 35:
                      if (!((_store$getState$actio = store.getState().actionCommands.actions[0]) === null || _store$getState$actio === void 0 ? void 0 : _store$getState$actio.missionsTutorial) && hasObjectValues(store.getState().missions.data)) actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 42);

                    case 37:
                      if (((_actions$i$gameTutori = actions[i].gameTutorial) === null || _actions$i$gameTutori === void 0 ? void 0 : _actions$i$gameTutori.gameId) && utils.quickObjectComparision(store.getState().actionCommands.lastActionExecuted, actions[i]) === false) actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 42);

                    case 39:
                      if (utils.quickObjectComparision(store.getState().actionCommands.lastActionExecuted, actions[i]) === false) actionsValidated.push(actions[i]);
                      return _context2.abrupt("break", 42);

                    case 41:
                      return _context2.abrupt("break", 42);

                    case 42:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })(), "t0", 5);

          case 5:
            _context3.next = 10;
            break;

          case 7:
            _context3.prev = 7;
            _context3.t1 = _context3["catch"](3);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context3.t1, Object.getOwnPropertyNames(_context3.t1)),
              body: JSON.stringify(actions[i]),
              code: ERROR_CODE.ACTIONS_COMANDS_VALIDATION_ERROR
            });

          case 10:
            i++;
            _context3.next = 2;
            break;

          case 13:
            j = 0;

          case 14:
            if (!(j < actionsValidated.length)) {
              _context3.next = 29;
              break;
            }

            _context3.prev = 15;

            if (!(actionsValidated[j].modal && actionsValidated[j].modal.assetsPackageId)) {
              _context3.next = 21;
              break;
            }

            _context3.next = 19;
            return getAssetsPackage(actionsValidated[j].modal.assetsPackageId);

          case 19:
            assetsLoaded = _context3.sent;
            if (!assetsLoaded) actionsValidated.splice(j, 1);

          case 21:
            _context3.next = 26;
            break;

          case 23:
            _context3.prev = 23;
            _context3.t2 = _context3["catch"](15);
            Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
              error: JSON.stringify(_context3.t2, Object.getOwnPropertyNames(_context3.t2)),
              code: ERROR_CODE.ACTIONS_COMANDS_ASSETS_ERROR
            });

          case 26:
            j++;
            _context3.next = 14;
            break;

          case 29:
            return _context3.abrupt("return", actionsValidated);

          case 30:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 7], [15, 23]]);
  }));

  return function validateActionCommand(_x2) {
    return _ref4.apply(this, arguments);
  };
}();